import React, { useCallback, useEffect, useState } from 'react'
import { useTranslate, useLocaleState, useGetList, SelectInput, required } from 'react-admin'
import { COMMON_FIELDS } from '../../providers/localization/constant'
import { BranchSelectInputProps } from './type'

export const BranchSelectInput: React.FC<BranchSelectInputProps> = ({
  source,
  excludeConfigured = false,
  defaultValue = '',
  ...props
}) => {
  const translate = useTranslate()
  const [locale] = useLocaleState()
  const optionRenderer = useCallback(
    (choice): string =>
      `${choice['branch_code']} ${choice[`branch_name_${locale}`] || choice['branch_name_th']}`,
    [locale],
  )

  const [choices, setChoices] = useState([])
  const [firstChoices, setFirstChoices] = useState()
  const { data, isLoading } = useGetList('branches', {
    pagination: { page: 1, perPage: 50 },
    filter: { ...(excludeConfigured && { exclude: 'configured' }) },
    sort: { field: 'branch_code', order: 'ASC' },
    meta: { isPaginate: false },
  })

  useEffect(() => {
    if (!isLoading && data) {
      setChoices(data)
      setFirstChoices(data[0].id)
    }
  }, [data, isLoading])

  return (
    <SelectInput
      source={source}
      margin='none'
      label={translate(`${COMMON_FIELDS}.specific_branches.label`)}
      optionText={optionRenderer}
      optionValue='branch_code'
      choices={choices}
      defaultValue={defaultValue ?? firstChoices}
      validate={[required()]}
      isLoading={isLoading}
      fullWidth
      {...props}
    />
  )
}
